// extracted by mini-css-extract-plugin
module.exports = {"DrawerAnimationDuration":"500ms","DrawerContainer":"DrawerContainer__3a6Rg"};